import { gql } from "graphql-tag";
import {
  ApolloClient,
  ApolloQueryResult,
  InMemoryCache,
} from "@apollo/client/core";
import type { Corollary } from "@/models/common";
import type { GotAppGroups } from "@/models/manager";

const query = gql`
  query getAppGroups {
    getAppGroups {
      __typename
      ... on GotAppGroups {
        success
        appGroups {
          appgroupId
          accountId
          name
          expiresAt
        }
      }
      ... on Corollary {
        code
        message
      }
    }
  }
`;

export type getAppGroupsResponse = ApolloQueryResult<{
  getAppGroups: GotAppGroups | Corollary;
}>;

export interface AppGroupsResponse {
  __typename?: string;
  appGroups?: GotAppGroups;
  failure?: { message: string; code: string };
}

/**
 * Retrieve all of the service groups belonging to the account.
 * @param client - apollo client.
 * @returns Resolved promise with all the ServiceGroups related to the account
 */
export async function getAllServiceGroups(
  client: ApolloClient<InMemoryCache>
): Promise<AppGroupsResponse> {
  const response: getAppGroupsResponse = await client.query({
    query,
    fetchPolicy: "no-cache",
  });
  const typeName = response.data.getAppGroups.__typename;
  return typeName === "GotAppGroups"
    ? {
        appGroups: response.data.getAppGroups as GotAppGroups,
      }
    : {
        failure: response.data.getAppGroups as Corollary,
      };
}
